import Vue from 'vue';
import Axios from 'axios';
import gsap from 'gsap';
import overview from '../../mixins/overview.js';
import transition_staggered_fade from '../../mixins/transition-staggered-fade-mixin.js';

Vue.component('overview-filternewsmembers-block', {
    mixins: [overview, transition_staggered_fade],
    data: function() {
        return {
            loadItems: 200,
            types: [],
            itemsPerPage: 12
        };
    },
    computed: {
        pages: function() {
            if (this.filteredResults.length % this.itemsPerPage == 0) {
                return this.filteredResults.length / this.itemsPerPage;
            }
            return Math.ceil(this.filteredResults.length / this.itemsPerPage);
        },

        options: function() {
            return this.searchResults.reduce((themes, result) => {
                const newThemes = result.Themes.filter(c => {
                    return themes.find(d => d.value == c.Id) == null;
                });
                themes.push.apply(
                    themes,
                    newThemes.map(t => {
                        return { label: t.Name, value: t.Id };
                    })
                );

                return themes;
            }, []);
        },
        filteredResults: function() {
            if (this.types.length > 0) {
                return this.searchResults.filter(result => {
                    return (
                        result.Themes.find(c => {
                            return this.types.find(d => d == c.Id) != null;
                        }) != null
                    );
                });
            }
            return this.searchResults;
        },
        pageResults: function() {
            return this.filteredResults.slice(
                this.currentPage * this.itemsPerPage - this.itemsPerPage,
                this.currentPage * this.itemsPerPage
            );
        },

        typesObj: function() {
            const obj = {};
            this.types.forEach(item => {
                obj[item] = true;
            });
            return obj;
        }
    },

    watch: {
        currentPage: function() {},
        options: function() {
            // Remove selected types not in possible options.
            this.types = this.types.filter(type => {
                return (
                    this.options.find(option => option.value == type) != null
                );
            });
        }
    },
    methods: {
        toggleFilter: function(filter) {
            this.currentPage = 1;
            !(this.types.indexOf(filter) != -1)
                ? this.types.push(filter)
                : this.types.splice(this.types.indexOf(filter), 1);
        },

        getItems: function() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            const getUrl =
                '/umbraco/api/search/getOverviewContent?q=' +
                this.searchQuery +
                '&page=' +
                this.currentPage +
                this.currentPageId +
                '&itemsPerPage=' +
                this.loadItems +
                '&v=' +
                Date.now();
            Axios.get(getUrl).then(response => {
                if (response.status == 200 && response.data.data) {
                    this.searchResults = response.data.data;
                    this.resultsCount = response.data.results;
                    this.emptyResult =
                        response.data.results != 0 ? false : true;

                    const params = new URLSearchParams(window.location.search);
                    if (params.has('themes')) {
                        const themes = params.get('themes');
                        const themeIds = themes.split(',');
                        themeIds.forEach(themeId => {
                            const parsedId = parseInt(themeId);
                            if (parsedId) {
                                this.toggleFilter(parsedId);
                            }
                        });
                    }
                }
                this.loading = false;
                gsap.to(window, 1, {
                    scrollTo: { y: 0, autoKill: true },
                    delay: 0,
                    ease: 'cubic.easeOut'
                });
            });
        },

        currentPageWatcher: function() {}
    }
});
